import { post } from "../../infra/rest";

export const getPaymentPageUrl = async (addonId?: string): Promise<{ paymentPageUrl: string }> => {
    return post<{ paymentPageUrl: string }>(
        `/v1/plan/upsell/payment-page`,
        {
            body: JSON.stringify({
                addonId,
            }),
        },
        true
    );
}